import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=8797f508&"
import script from "./noPermission.vue?vue&type=script&lang=ts&"
export * from "./noPermission.vue?vue&type=script&lang=ts&"
import style0 from "./noPermission.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports